import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { useLanguage } from '../context/LanguageContext';
import { ArrowRight, Heart, Sparkles } from 'lucide-react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const MyStoryPreview = () => {
  const [storyContent, setStoryContent] = useState(null);
  const { language } = useLanguage();

  useEffect(() => {
    const fetchStory = async () => {
      try {
        const response = await axios.get(`${API_URL}/api/mystory`);
        if (response.data && Object.keys(response.data).length > 0) {
          setStoryContent(response.data);
        }
      } catch (error) {
        console.log('Using default story preview');
      }
    };
    fetchStory();
  }, []);

  // Translations
  const translations = {
    en: {
      sectionTitle: "My Story",
      defaultTitle: "My Journey with LifeWave",
      defaultIntro: "Discover how LifeWave technology changed my life and how it can help you too...",
      readMore: "Read My Full Story"
    },
    ro: {
      sectionTitle: "Povestea Mea",
      defaultTitle: "Călătoria Mea cu LifeWave",
      defaultIntro: "Descoperă cum tehnologia LifeWave mi-a schimbat viața și cum te poate ajuta și pe tine...",
      readMore: "Citește Povestea Completă"
    },
    es: {
      sectionTitle: "Mi Historia",
      defaultTitle: "Mi Viaje con LifeWave",
      defaultIntro: "Descubre cómo la tecnología LifeWave cambió mi vida y cómo puede ayudarte a ti también...",
      readMore: "Lee Mi Historia Completa"
    },
    it: {
      sectionTitle: "La Mia Storia",
      defaultTitle: "Il Mio Viaggio con LifeWave",
      defaultIntro: "Scopri come la tecnologia LifeWave ha cambiato la mia vita e come può aiutare anche te...",
      readMore: "Leggi la Mia Storia Completa"
    },
    de: {
      sectionTitle: "Meine Geschichte",
      defaultTitle: "Meine Reise mit LifeWave",
      defaultIntro: "Entdecke, wie die LifeWave-Technologie mein Leben verändert hat und wie sie auch dir helfen kann...",
      readMore: "Lies Meine Vollständige Geschichte"
    }
  };

  const t = translations[language] || translations['en'];
  const customContent = storyContent?.[language];
  
  const title = customContent?.title || t.defaultTitle;
  const intro = customContent?.intro || t.defaultIntro;

  return (
    <section className="py-16 bg-gradient-to-br from-rose-50 via-white to-amber-50">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-8">
          <div className="inline-flex items-center gap-2 bg-rose-100 text-rose-700 px-4 py-2 rounded-full text-sm font-medium mb-4">
            <Heart className="w-4 h-4" />
            {t.sectionTitle}
          </div>
        </div>

        <Link 
          to="/my-story"
          className="block group"
        >
          <div className="bg-white rounded-3xl shadow-lg hover:shadow-xl transition-all duration-300 overflow-hidden border border-rose-100">
            <div className="p-8 sm:p-12">
              <div className="flex items-start gap-4 mb-6">
                <div className="w-16 h-16 bg-gradient-to-br from-rose-400 to-amber-400 rounded-2xl flex items-center justify-center flex-shrink-0">
                  <Sparkles className="w-8 h-8 text-white" />
                </div>
                <div className="flex-grow">
                  <h2 className="text-2xl sm:text-3xl font-bold text-slate-900 mb-3 group-hover:text-rose-600 transition-colors">
                    {title}
                  </h2>
                  <p className="text-slate-600 text-lg leading-relaxed line-clamp-3">
                    {intro}
                  </p>
                </div>
              </div>
              
              <div className="flex justify-end">
                <span className="inline-flex items-center gap-2 text-rose-600 font-semibold group-hover:gap-3 transition-all">
                  {t.readMore}
                  <ArrowRight className="w-5 h-5" />
                </span>
              </div>
            </div>
          </div>
        </Link>
      </div>
    </section>
  );
};

export default MyStoryPreview;
